import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import LoadingPage from "../utils/LoadingPage";
import addIcon from "../../images/addIcon.svg";
import searchIcon from "../../images/searchIcon.svg";
import "../../styles/newstyles/unitdetails.css";
import Ntable from "./Ntable";
import { GetNotification, GetQuery } from "../../redux/api";

const Notification = () => {
  const history = useHistory();
  const { id } = useParams();
  const [QueryData, setQueryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchInput, setsearchInput] = useState("");
  const [filterData, setfilterData] = useState([]);

  useEffect(() => {
    Query();
  }, []);

  // api call

  const Query = async () => {
    try {
      const data = await GetNotification();
      setQueryData(data?.data?.notification);
      console.log(data.data.notification);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const searchItems = (searchValue) => {
    setsearchInput(searchValue);
    if (searchValue !== "") {
      let filteredData = QueryData.filter((item) => {
        return Object.values(item)
          .join("")
          .toLowerCase()
          .includes(searchValue.toLowerCase());
      });
      setfilterData(filteredData);
    } else {
      setfilterData(QueryData);
    }
  };

  return (
    <div className="unitdetails-container">
      {loading ? (
        <LoadingPage />
      ) : (
        <>
          <div className="unitdetails-firstSection">
            <div className="unitdetails-searchDiv">
              <img src={searchIcon} alt="search" className="searchIcon" />
              <input
                type="text"
                placeholder="Enter a Name , Description or More"
                className="unitdetails-searchInput"
                id="searchInput"
                value={searchInput}
                onChange={(e) => searchItems(e.target.value)}
              />
            </div>
            <button
              className="unitdetails-addBtn unitdetails-addBtn1"
              onClick={() => history.push("/notifications/add")}
            >
              <img src={addIcon} alt="add" className="addIcon mx-2" />
              Add Ticket
            </button>
          </div>
          <div className="unitdetails-tableSection">
            {searchInput.length ? (
              <Ntable QueryData={filterData} />
            ) : (
              <Ntable QueryData={QueryData} />
            )}
          </div>
        </>
      )}
    </div>
  );
};
export default Notification;
